import script from "./xtx-confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-confirm.vue?vue&type=script&setup=true&lang=js"

import "./xtx-confirm.vue?vue&type=style&index=0&id=4518d4dd&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4518d4dd"]])

export default __exports__